// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SidebarComments-cls1___49fa5b9056a538769a4{/*!*/}.SidebarComments-cls2__b6a5472fba90ce3befba{margin-top:20px;border-top:1px solid #141413;border-top:1px solid var(--stroke-dark, #141413)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SidebarComments-cls1___49fa5b9056a538769a4",
	"cls2": "SidebarComments-cls2__b6a5472fba90ce3befba SidebarComments-cls1___49fa5b9056a538769a4"
};
export default ___CSS_LOADER_EXPORT___;
